import { RemoveRedEye } from "@mui/icons-material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import { Input, TextArea } from "components/Form";
import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import toast from "react-hot-toast";
import Pagination from "react-js-pagination";
import { useNavigate } from "react-router-dom";
import { getPaymentLinkList } from "services/payments";
import * as XLSX from "xlsx";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { getRefundList, getRefundRejectedList, initiateRefund } from "services/paymentRefundManagement";
import { encryptData } from "config/config";
import ChatIcon from "@mui/icons-material/Chat";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { dateFormat } from "utils";

export default function RejectedRefunds() {
    const navigate = useNavigate();
    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const [mentorid, setmentorid] = useState("");
    const [activePage, setActivePage] = useState(1);
    const [selectedData, setSelectedData] = useState({});

    const [blockModal, setBlockModal] = useState(false);
    const [commentModal, setCommentModal] = useState(false);
    const [comment, setComment] = useState("");
    const [accountcomment, setAccountComment] = useState("");
    const [bankupdatecomment, setBankupdatecomment] = useState("");
    const [data, setData] = useState({});
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [submitButtonElement2, setSubmitLoading2] = useMuiButtonLoader();
    const [expandedRow, setExpandedRow] = useState(null);
    const [refundConfirmModal, setRefundConfirmModal] = useState(false);

    const usertypeid = localStorage.getItem("roleid")
    // ************************ Fetch Record ****************************
    const handleRecord = async () => {
        showLoader();
        try {
            const res = await getRefundRejectedList({
                page: activePage,
                limit: limit,
                search: search,
            });
            hideLoader();
            if (res.code === 200) {
                const { rows, count } = res.data.refundrecords;
                setRecord(rows || []);
                setTotal(count || 0);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
        hideLoader();
    };

    useEffect(() => {
        handleRecord();
    }, [activePage, search, limit]);

    //   ************************************** Export to excel ***************************************************

    const downloadHandler = async () => {
        try {
            const res = await getRefundRejectedList({ type: "excel" });
            const { rows, count } = res.data.paymentLinks;
            const data = rows.map(
                (
                    {
                        id,
                        firstname,
                        lastname,
                        email,
                        mobile,
                        paymentlink,
                        paymentstatus,
                        coursetitle,
                        amount,
                        discount,
                        couponcode,
                        totalamount,
                        addedby,
                        addedOn,
                    },
                    i
                ) => {
                    return {
                        "S.No": i + 1,
                        "Send By": addedby,
                        "Payment link": paymentlink,
                        "Payment Refund Status": paymentstatus,
                        // "Course Fee": amount,
                        // "Course Discount": discount,
                        // "Coupon Code": couponcode,
                        Amount: totalamount,
                        "Student Name": firstname + " " + lastname,
                        Mobile: mobile,
                        Email: email,
                        "Course Name": coursetitle,
                    };
                }
            );
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, "Payment_links.xlsx");
        } catch (err) {
            console.error("Error downloading Excel file:", err);
        }
    };

    // ******************************************* Handle Copy paste ******************************************************
    const [showCopied, setShowCopied] = useState(false);
    const [index, setIndex] = useState("");

    const handleCopy = (text) => {
        // Copy the text to clipboard using the Clipboard API
        navigator.clipboard
            .writeText(text)
            .then(() => {
                setShowCopied(true);

                // Hide the "Copied" message after 2 seconds
                setTimeout(() => {
                    setShowCopied(false);
                }, 2000);
                console.log("Text copied to clipboard");
            })
            .catch((err) => {
                console.error("Failed to copy text: ", err);
            });
    };


    const handleRefundInitiation = async () => {
        setSubmitLoading(true);
        try {
            const detailRes = await initiateRefund(selectedData);
            if (detailRes.code === 200) {
                setRefundConfirmModal(false);
                setSubmitLoading(false);
                toast.success(detailRes.message);
                handleRecord();
            } else {
                setRefundConfirmModal(false);
                setSubmitLoading(false);
                toast.error(detailRes.message);
                handleRecord();
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
            setSubmitLoading(false);
        }
    };


    return (
        <>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="search_wrap">
                                <div className="SearchBox">
                                    <div>
                                        <Input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control"
                                            name="search"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </div>
                                    <div className="div_no_wrap mx-1 row"></div>

                                    {/* <div className="mx-2">
                    <Button onClick={downloadHandler} {...submitButtonElement}>
                      Export To Excel
                    </Button>
                  </div> */}
                                    <div>
                                        {/* <Button
                      type="acl"
                      role={6000010}
                      to={"/payment-refunds/send-payment-refund-link"}
                    //   {...submitButtonElement}
                    >
                      Send Payment Refund Link
                    </Button> */}
                                    </div>
                                </div>
                            </div>
                            <h4 className="Title"> Rejected Refunds List</h4>
                        </div>

                        <div className="TableList overflow-auto table-responsive">
                            {loader}
                            <Table bordered className="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>S.No</th>
                                        <th>Unique ID</th>
                                        <th>Student Name</th>
                                        <th>Course Name</th>
                                        {/* <th className="text-center">Link</th> */}
                                        <th className="text-center">Status</th>
                                        {/* <th className="text-center">App. Amount</th> */}
                                        <th className="text-center">Comment</th>
                                        <th className="text-center" >Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {record && record.length > 0 ? (
                                        record.map((row, i) => {
                                            const isOpen = expandedRow === i;
                                            return (
                                                <React.Fragment key={i}>
                                                    <tr>
                                                        <td>
                                                            <IconButton
                                                                aria-label="expand row"
                                                                size="small"
                                                                onClick={() => setExpandedRow(isOpen ? null : i)}
                                                            >
                                                                {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                            </IconButton>
                                                        </td>
                                                        <td>{i + 1 + (activePage - 1) * limit}</td>
                                                        <td>{`REF - ${row.refundlinkid}`}</td>
                                                        <td>{row.firstname} {row.lastname}</td>
                                                        <td style={{ maxWidth: "380px", whiteSpace: "normal", wordWrap: "break-word" }}> {row.coursename} </td>
                                                        {/* <td>
                              <div className="d-flex justify-content-center">
                                <IconButton type="acl" role={520001} aria-label="view" className="px-1 py-0"
                                  onClick={() => { setData({ ...data, link: row.refundlink || "" }); setBlockModal(true); }} >
                                  <RemoveRedEye sx={{ color: "#4971B2" }} />
                                </IconButton>
                                <IconButton type="acl" role={520002} aria-label="view" className="px-1 py-0"
                                  onClick={() => { handleCopy(row.refundlink || ""); setIndex(i); }} >
                                  {showCopied && index == i && !blockModal && (
                                    <div style={{ position: "absolute", top: "-27px", left: "50%", transform: "translateX(-50%)", padding: "5px ", backgroundColor: "rgb(73, 224, 91)", color: "white", borderRadius: "5px", fontSize: "10px", zIndex: "10", }} >
                                      Copied! </div>)} <ContentCopyIcon sx={{ color: "#4971B2" }} /> </IconButton> </div>
                            </td> */}
                                                        <td
                                                            className="text-center"
                                                            style={{ color: "red", fontWeight: "500" }}
                                                        >
                                                            {row.refunddetails?.status}
                                                        </td>

                                                        {/* <td style={{ textAlign: "center" }}>
                              {row.refunddetails?.approvedamount || "-"}
                            </td> */}
                                                        <td> <div className="d-flex justify-content-center"> {(Object.keys(row.refunddetails || {}).length > 0 && row.refunddetails?.comment && (<IconButton type="acl" role={520003}> <ChatIcon style={{ color: "#1976d2", cursor: "pointer", }} onClick={() => { setComment(row.refunddetails?.comment || ""); setAccountComment(row.refunddetails?.accountcomment || ""); setBankupdatecomment(row?.acconutupdatecomment || ""); setCommentModal(true); }} /> </IconButton>)) || "N/A"} </div>
                                                        </td>

                                                        <td >
                                                            <Button
                                                                type="acl"
                                                                role={520015}
                                                                onClick={() => {
                                                                    setSelectedData({
                                                                        ...selectedData,
                                                                        id: row?.refunddetails.id,
                                                                        refundid: row.refundlinkid,
                                                                        courseid: row.courseid,
                                                                        studentid: row.studentid,
                                                                    });
                                                                    setRefundConfirmModal(true);
                                                                }}
                                                            >
                                                                Initiate Refund
                                                            </Button>
                                                        </td>

                                                    </tr>

                                                    {isOpen && (
                                                        <tr>
                                                            <td></td>
                                                            <td colSpan={10}>
                                                                <div className="p-2 rounded" style={{ backgroundColor: "#f3f8ff" }}>
                                                                    <div className="row">
                                                                        {/* --- Column 1 --- */}
                                                                        <div className="col-md-4">
                                                                            <p className="mb-1 text-start">
                                                                                <span style={{ fontWeight: "500", color: "black" }}>Email ID:</span> {row.email || "-"}
                                                                            </p>
                                                                            <p className="mb-1 text-start">
                                                                                <span style={{ fontWeight: "500", color: "black" }}>Mobile:</span> {row.mobile || "-"}
                                                                            </p>
                                                                        </div>

                                                                        {/* --- Column 2 --- */}
                                                                        <div className="col-md-4">
                                                                            <p className="mb-1 text-start">
                                                                                <span style={{ fontWeight: "500", color: "black" }}>Course Fees:</span> {row.coursefees || "-"}
                                                                            </p>
                                                                            <p className="mb-1 text-start">
                                                                                <span style={{ fontWeight: "500", color: "black" }}>Paid Fees:</span> {row.paidfees || "-"}
                                                                            </p>
                                                                        </div>

                                                                        {/* --- Column 3 --- */}
                                                                        <div className="col-md-4">
                                                                            <p className="mb-1 text-start">
                                                                                <span style={{ fontWeight: "500", color: "black" }}>Send By:</span> {row.sendby || "-"}
                                                                            </p>
                                                                            <p className="mb-1 text-start">
                                                                                <span style={{ fontWeight: "500", color: "black" }}>Link Send Date:</span>{" "}
                                                                                {row.addedon ? dateFormat(row.addedon) : "-"}
                                                                            </p>
                                                                        </div>

                                                                        {/* --- Optional Fields (only show if present) --- */}
                                                                        {row.refunddetails?.paymentmode && (
                                                                            <div className="col-md-4">
                                                                                <p className="mb-1 text-start">
                                                                                    <span style={{ fontWeight: "500", color: "black" }}>Payment Mode:</span>{" "}
                                                                                    {row.refunddetails.paymentmode}
                                                                                </p>
                                                                            </div>
                                                                        )}

                                                                        {row.refunddetails?.transactionid && (
                                                                            <div className="col-md-4">
                                                                                <p className="mb-1 text-start">
                                                                                    <span style={{ fontWeight: "500", color: "black" }}>Transaction ID:</span>{" "}
                                                                                    {row.refunddetails.transactionid}
                                                                                </p>
                                                                            </div>
                                                                        )}

                                                                        {row.refunddetails?.refunddate && (
                                                                            <div className="col-md-4">
                                                                                <p className="mb-1 text-start">
                                                                                    <span style={{ fontWeight: "500", color: "black" }}>Refund Date:</span>{" "}
                                                                                    {dateFormat(row.refunddetails.refunddate)}
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </td>

                                                        </tr>



                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <NotFound cols={11} />
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        {total > limit ? (
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={limit}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={(e) => setActivePage(e)}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
            {/* *********************************************** Payement link modal *************************************************** */}
            <ModalBox
                status={blockModal}
                onClose={() => setBlockModal(false)}
                title={"Payment Refund Link"}
                size={"sm"}
                description={
                    <>
                        <div className="form-group row">
                            <div className="col-sm-12 col-form-label d-flex g-2">
                                <Input
                                    type="text"
                                    name="link"
                                    value={data.link}
                                    //   onChange={onChangeHandler}
                                    placeholder="Enter Title"
                                    className={`form-control`}
                                    maxLength={60}
                                    // label={"Link"}
                                    disabled
                                //   error={errorField.section_name}
                                //   required
                                />
                                <IconButton
                                    aria-label="view"
                                    className="px-1 py-0"
                                    onClick={() => {
                                        handleCopy(data.link || "");
                                        // setData({ ...data, link: paymentlink || "" });
                                        // setBlockModal(true);
                                        //   navigate(`book-slot/${UserID}/${Name}`);
                                    }}
                                >
                                    {showCopied && (
                                        <div
                                            style={{
                                                width: "fit-content",
                                                height: "fit-content",
                                                position: "absolute",
                                                top: "-15px", // Position above the button
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                padding: "3px",
                                                backgroundColor: "rgb(73, 224, 91)",
                                                color: "white",
                                                borderRadius: "5px",
                                                fontSize: "9px",
                                                zIndex: "1000",
                                            }}
                                        >
                                            Copied!
                                        </div>
                                    )}
                                    <ContentCopyIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                            </div>
                            <div className="col-sm-1 col-form-label"></div>
                        </div>
                    </>
                }
                // customizedFooter={
                //   <Button
                //     //   onClick={updateCenterStatusHandler}
                //     {...submitButtonElement}
                //   >
                //     Yes
                //   </Button>
                // }
                customizedFooter={true}
                custom={false}
                Close={true}
            />

            {/* *********************************************** Comment modal *************************************************** */}
            <ModalBox
                status={commentModal}
                onClose={() => setCommentModal(false)}
                title={"Comment"}
                size={"sm"}
                description={
                    <>
                        <div className="form-group row">
                            <div className="col-sm-12 col-form-label">
                                {(accountcomment != "" || accountcomment === null) && (<div className="col-sm-12 col-form-label">
                                    <TextArea
                                        type="text"
                                        name="accountcomment"
                                        value={accountcomment}
                                        placeholder=""
                                        className={`form-control `}
                                        label="Account Dept Comment"
                                        rows={7}
                                        readOnly
                                    />
                                </div>
                                )}
                                <TextArea
                                    type="text"
                                    name="comment"
                                    value={comment}
                                    placeholder="Enter Comment"
                                    className={`form-control `}
                                    label="Rejected Comment"
                                    rows={7}
                                    readOnly
                                />
                            </div>
                            {/* {(bankupdatecomment != "" || bankupdatecomment === null) && (<div className="col-sm-12 col-form-label">
                <TextArea
                  type="text"
                  name="acconutupdatecomment"
                  value={bankupdatecomment}
                  placeholder=""
                  className={`form-control `}
                  label="Bank Account Details Update Comment"
                  rows={7}
                  readOnly
                />
              </div>
              )} */}

                        </div>
                    </>
                }
                // customizedFooter={
                //   <Button
                //     //   onClick={updateCenterStatusHandler}
                //     {...submitButtonElement}
                //   >
                //     Yes
                //   </Button>
                // }
                customizedFooter={true}
                custom={false}
                Close={true}
            />
            <ModalBox
                status={refundConfirmModal} // boolean state like: const [refundConfirmModal, setRefundConfirmModal] = useState(false);
                onClose={() => setRefundConfirmModal(false)}
                title={"Initiate Refund"}
                size={"sm"}
                description={
                    <>
                        <div
                            className="text-center"
                            style={{ paddingTop: 0, paddingBottom: 0 }}
                        >
                            <p className="text-lg font-medium text-gray-800" style={{ marginBottom: 0 }}>
                                Are you sure you want to initiate the refund process for this transaction?
                            </p>
                        </div>

                    </>
                }
                customizedFooter={
                    <div className="flex justify-end gap-3 px-4 pb-4" style={{ gap: "20px", display: "flex" }}>
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => setRefundConfirmModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleRefundInitiation} // your function to trigger refund

                        >
                            Yes, Initiate
                        </button>
                    </div>
                }
                custom={true} // because you’re using a custom footer
                Close={true}
            />

        </>
    );
}
